import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import Typography from "@components/typography";
import Fields from "@components/fields";
import Button from "@components/button";
import { Order } from "@apis/index";
import { toast } from "react-toastify";
import { useModal } from "@context/ModalContext";

interface AcceptOrderModalProps {
  orderId: number | string;
  hideModal: () => void;
  onSuccess?: () => void;
}

const AcceptOrderModal: React.FC<AcceptOrderModalProps> = ({
  orderId,
  hideModal,
  onSuccess,
}) => {
  return (
    <Formik
      initialValues={{ processingTime: "15 min - 20min" }} // Default 15 mins
      onSubmit={async (values, { setSubmitting }) => {
        try {
          await Order.acceptOrder(
            orderId,
            values.processingTime.toString(),
          ).then(() => {});
          toast.success("Order accepted successfully");
          if (onSuccess) onSuccess();
          hideModal();
        } catch (error: any) {
          toast.error(error.message || "Failed to accept order");
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <Typography styleText="font-size:18px;font-weight:600;margin-bottom:12px;">
            Accept Order
          </Typography>
          <Typography styleText="font-size:14px;color:#666;margin-bottom:20px;">
            Please specify the estimated processing time for this order.
          </Typography>

          <Fields.Input
            name="processingTime"
            label="Processing Time (10 min - 20 min)"
            type="text"
            placeholder="e.g. 15 min - 20 min"
          />

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            <Button
              title="Cancel"
              variant="outline"
              type="button"
              onClick={hideModal}
            />
            <Button
              title={isSubmitting ? "Accepting..." : "Accept Order"}
              type="submit"
              disabled={isSubmitting}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AcceptOrderModal;
